














import createForm from '@/activeForms/wiki/createPage'
import Vue, {VueConstructor} from 'vue'
export default (Vue as VueConstructor<Vue & {
  $refs: {
    form: { reset: () => void },
  }
}>).extend({
  data () {
    return {
      data: {},
      createForm
    }
  },
  methods: {
    onCreated (item: any) {
      console.log('LOG: onCreated -> item', item)
      this.$message({
        // @ts-ignore
        message: this.$t('wiki.node_added'),
        type: 'success'
      });
      // this.data = {}
      // this.$refs.form.reset()
      this.$router.push({name: 'wikiPage', params: {id: item.id}})
    },
    onError () {
      this.$message({
        // @ts-ignore
        message: this.$t('wiki.create_error'),
        type: 'error'
      });
    }
  }
})
